/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentAlarmConfiguration {
    getFixupPrototypeFunction() { return AwsSsmDocumentAlarmConfiguration.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentAlarmConfiguration>): AwsSsmDocumentAlarmConfiguration {
        let obj = Object.assign(new AwsSsmDocumentAlarmConfiguration(), model);
        AwsSsmDocumentAlarmConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentAlarmConfiguration>): AwsSsmDocumentAlarmConfiguration {
        if (!model) return null;
        return AwsSsmDocumentAlarmConfiguration.newInstance(<AwsSsmDocumentAlarmConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentAlarmConfiguration) {
        if (!obj) return;

        models.AwsSsmDocumentAlarmConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentAlarmConfiguration): boolean {
        Object.setPrototypeOf(obj, AwsSsmDocumentAlarmConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.alarms) {
            for (let val of this.alarms) {
                models.AwsSsmCommandDocumentAlarm.fixupPrototype(val);
            }
        }
    }

    /**
     * The automation or command continues to run, either the Alarm status is OK or INSUFFICIENT_DATA.
     */
    ignore_poll_alarm_failure: boolean;

    /**
     * List of Alarms.
     */
    alarms: Array<models.AwsSsmCommandDocumentAlarm>;

}
